<template>
  <main id="main"
    v-hammer:tap="onTap"
    class="product-guide -hidefilter p-t-36 grid"
    :class="{ '-mobiletools': viewMobileTools }"
  >
    <transition name="fade">
      <div v-show="viewMobileTools" class="product-guide-overlay" />
    </transition>
    <h1 v-if="isMobile" class="font-responsive-larger m-b-18">
      {{ header.DisplayName }}
    </h1>
    <!-- TOOLS -->
    <section
      ref="tools"
      class="product-guide-tools"
      :class="stickyTools ? 'g-md-4' : 'grid-12'"
    >
      <h1
        v-if="!stickyTools && !isMobile"
        class="g-md-4 font-responsive-larger"
      >
        {{ header.DisplayName }}
      </h1>

      <section
        :class="[
          stickyTools ? 'grid-4 m-t-18 -stickytools' : 'grid-md-8',
          { '-open': viewMobileTools },
        ]"
      >
        <h1
          v-if="stickyTools && !isMobile"
          class="font-responsive-larger m-b-18"
        >
          {{ this.header.DisplayName }}
        </h1>
        <div class="product-guide-performance g-md-3 m-t-18 m-t-md-0">
          <div
            class="product-guide-performance-header d-flex justify-content-between m-b-9"
          >
            <div class="font-responsive-body">
              {{ insertString("ProductPage", "Performance") }}:
            </div>
            <button
              v-if="filterCount > 0"
              type="button"
              class="-clickable -stripped -underline"
              @click.stop="clearFilters()"
            >
              <SvgComponent
                v-show="false"
                :icon="{ name: 'Close' }"
              ></SvgComponent>
              <span class="m-l-6 font-responsive-body">{{
                insertString("Global", "Clear")
              }}</span>
            </button>
          </div>
          <div class="select-wrapper">
            <SelectSimple
              v-model="performance[0]"
              :options="performanceList"
              :placeholder="insertString('ProductGuide', 'FirstPriority')"
              :block="!isMobile"
              :frame="true"
              @change="enableShuffle"
              :aria-label="insertString('ProductGuide', 'FirstPriority') + 'Filter'"
            />
            <SelectSimple
              class="m-t-md-18"
              v-model="performance[1]"
              :options="filterPerformanceList(1)"
              :placeholder="insertString('ProductGuide', 'SecondPriority')"
              :block="!isMobile"
              :frame="true"
              :disabled="!performance[0]"
              @change="enableShuffle"
                :aria-label="insertString('ProductGuide', 'SecondPriority') + 'Filter'"
            />
            <SelectSimple
              class="m-t-md-18"
              :class="{ 'p-r-18': isMobile }"
              v-model="performance[2]"
              :options="filterPerformanceList(2)"
              :placeholder="insertString('ProductGuide', 'ThirdPriority')"
              :block="!isMobile"
              :frame="true"
              :disabled="!performance[0] || !performance[1]"
              @change="enableShuffle"
              :aria-label="insertString('ProductGuide', 'ThirdPriority') + 'Filter'"
            />
          </div>
        </div>
        <div class="g-md-1" />
        <div
          v-if="areaOfUseFilters"
          class="m-t-18"
          :class="!stickyTools ? 'g-md-4  m-t-md-0' : ''"
        >
          <div class="d-flex justify-content-between">
            <div class="font-responsive-body">
              {{ insertString("ProductGuide", "Uselabel") }}:
            </div>
            <!-- <div
              v-if="areaOfUseFilters.length > maxSetFilters"
              class="font-responsive-body"
            >
              ({{
                replaceAndInsert(
                  "max",
                  maxSetFilters,
                  "ProductGuide",
                  "MaxOptions"
                )
              }})
            </div> -->
          </div>

          <FilterList
            :model="areaOfUseFilters"
            :max="maxSetFilters"
            @filterHasChanged="filterHasChanged"
          />
        </div>
        <ButtonComponent
          v-if="isMobile"
          class="m-t-18"
          :text="insertString('ProductList', 'ResultButton')"
          :block="true"
          theme="cta"
          @click="closeMobileTools()"
        />
      </section>
    </section>
    <!-- LIST -->
    <section
      class="product-guide-body -small p-t-0"
      :class="stickyTools ? 'g-md-8' : 'grid'"
    >
      <section
        v-if="isMobile"
        class="topbar bar-container -md"
        :class="hideHeader ? '-scroll-up -scroll-up-bar' : ''"
      >
        <FilterToggler :label="'Filter & sort'" @toggle="openMobileTools()" />
      </section>
      <ProductCardList
        ref="products"
        :products="allProducts"
        :name="`Productguide;${header.DisplayName}`"
        :outlet="outlet"
        :split="false"
        :archived="false"
        :selectedColors="selectedColors"
        :selectedSizes="selectedSizes"
        :wishlistItems="$_wishlistItems"
        :showRatings="true"
        :shuffle="shuffelIsActive"
        :trackSourceObject="{
          performance: performance,
          areasOfUseFilter: areasOfUseFilter,
        }"
      />
    </section>
  </main>
</template>
<script>
import Api from '@/Scripts/api/api';
import { mapState } from 'vuex';
import stringHelper from '@/Scripts/lib/helper/stringHelper.js';
import { TrackerProductGuideViewed } from '@/Scripts/lib/helper/trackingHelper.js';
import FilterList from '@/Scripts/components/pages/ProductGuide/FilterList.vue';
import urlParamsHelper from '@/Scripts/lib/helper/urlParamsHelper.js';
import pageLoader from '@/Scripts/lib/helper/pageLoader.js';
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';
import FilterToggler from '@/Scripts/components/pages/productList/Assets/FilterToggler.vue';
import ButtonComponent from '@/Scripts/components/shared/ButtonV2/ButtonV2.vue';
import ProductCardList from '@/Scripts/components/pages/ProductList/ProductCardList/ProductCardList.vue';
import getWishlistMixin from '@/Scripts/lib/mixins/getWishlistMixin.js';

const SelectSimple = () => import(/* webpackChunkName: "SelectSimple" */ '@/Scripts/components/shared/SelectSimple/SelectSimple.vue');

export default {
  name: 'ProductGuide',
  mixins: [urlParamsHelper, pageLoader, getWishlistMixin],
  components: {
    // ProductAreaList,
    SelectSimple,
    FilterList,
    SvgComponent,
    ButtonComponent,
    FilterToggler,
    ProductCardList

    // Chevron
  },
  data () {
    return {

      shuffelIsActive: false,
      settings: {
        useFilterTags: false
      },
      productList: [],
      stickyTools: true,
      performanceInfo: null,
      specificUse: null,
      waitingForList: true,
      scrollPos: 0,
      maxSetFilters: 3,
      viewMobileTools: false,
      animatingTools: false,
      tracked: false,
      performanceList: [
        {
          label: this.insertString('ProductPage', 'Ratings', 'Windproofness'),
          value: 'Windproofness',
          id: 1
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Insulation'),
          value: 'Insulation',
          id: 2
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Waterproofness'),
          value: 'Waterproofness',
          id: 3
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Breathability'),
          value: 'Breathability',
          id: 4
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Durability'),
          value: 'Durability',
          id: 5
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Lightweight'),
          value: 'Lightweight',
          id: 6
        },
        {
          label: this.insertString('ProductPage', 'Ratings', 'Elastic'),
          value: 'Elastic',
          id: 7
        }
      ]
    };
  },
  computed: {
    ...mapState({
      products: state => state.productList.products,
      header: state => state.productList.header,
      selectedColors: state => state.productList.selectedColors,
      selectedSizes: state => state.productList.selectedSizes,

      productsLoading: state => state.productList.productsLoading,
      pageLoaded: state => state.productList.productPage,
      performance: state => state.productList.performanceSort,
      performanceRatingInfo: state => state.productList.performanceRatingInfo,
      areaOfUseGroups: state => state.productList.areaOfUseGroups,
      areasOfUseFilter: state => state.productList.areaOfUseFilters,
      hideHeader: state => state.appContext.hideHeader,
      outlet: state => state.productList.header.Outlet
    }),

    allProducts () {
      const list = [];

      // Filter and sort list by areas of use // only for guide pages
      if (this.areasOfUseFilter && this.areasOfUseFilter.length > 0) {
        for (let i = 0; i < this.productList.length; i++) {
          const hitlist = [];
          const aou = this.productList[i].AreasOfUse;
          for (let k = 0; k < this.areasOfUseFilter.length; k++) {
            let hit = false;
            const f = this.areasOfUseFilter[k];
            Object.keys(aou).forEach(key => {
              const value = aou[key];
              if (f.toLowerCase() === key.toLowerCase() && value > 0) {
                hit = true;
              }
            });
            hitlist.push(hit);
          }
          if (!hitlist.includes(false)) {
            list.push(this.productList[i]);
          }
        }
        return this.performance && this.performance.length > 0 ? this.sorted(list) : list;
      }
      // return productlist sorted by ratings for guide page
      return this.performance && this.performance.length > 0 ? this.sorted(this.productList) : this.products;
    },
    isMobile () {
      return this.$mqAliases.xs || this.$mqAliases.sm;
    },
    areasOfUseOnProducts () {
      // find all areas of use
      const list = [];
      this.products.forEach(item => {
        if (!item.AreasOfUse) {
          console.warn('Missing areas of use prop on product');
        } else {
          Object.keys(item.AreasOfUse).forEach(key => {
            if (item.AreasOfUse[key] > 0 && !list.includes(key)) {
              list.push(key);
            }
          });
        }
      });
      return list;
    },
    areasOfUseOnVisibleProducts () {
      // count on filtered products
      const list = [];
      this.allProducts.forEach(item => {
        if (!item.AreasOfUse) {
          console.warn('Missing areas of use prop on product');
        } else {
          Object.keys(item.AreasOfUse).forEach(key => {
            if (item.AreasOfUse[key] > 0) {
              list.push(key);
            }
          });
        }
      });
      return list;
    },
    areaOfUseFilters () {
      if (this.areaOfUseGroups && this.areaOfUseGroups.length > 0) {
        const list = [];
        this.areaOfUseGroups.forEach(group => {
          group.AreaOfUse.forEach(obj => {
            if (this.areasOfUseOnProducts.includes(obj.Name)) {
              const c = this.areasOfUseOnVisibleProducts.filter(val => val === obj.Name);
              obj.count = c.length;
              list.push(obj);
            }
          });
        });

        return list;
      }
      return null;
    },
    filterCount () {
      let count = 0;
      for (let i = 0; i < this.performance.length; i++) {
        if (this.performance[i] !== '' && this.performance[i] !== undefined) {
          count++;
        }
      }
      return count;
    }
  },
  methods: {
    enableShuffle () {
      if (!this.shuffelIsActive) {
        this.shuffelIsActive = true;
      }
    },
    sorted (list) {
      // sort list by ratings
      let arr = [...list];
      if (arr.length > 0) {
        arr = arr.sort((a, b) => {
          if (!a.AreasOfUse) {
            console.warn('Missing perforamnces');
            return 0;
          }
          if (a.AreasOfUse[this.areasOfUseFilter[0]] === b.AreasOfUse[this.areasOfUseFilter[0]]) {
            if (a.AreasOfUse[this.areasOfUseFilter[1]] === b.AreasOfUse[this.areasOfUseFilter[1]]) {
              return b.AreasOfUse[this.areasOfUseFilter[2]] - a.AreasOfUse[this.areasOfUseFilter[2]];
            }
            return b.AreasOfUse[this.areasOfUseFilter[1]] - a.AreasOfUse[this.areasOfUseFilter[1]];
          }
          return a.AreasOfUse[this.areasOfUseFilter[0]] > b.AreasOfUse[this.areasOfUseFilter[0]] ? -1 : 1;
        });

        return arr.sort((a, b) => {
          if (!a.Performance) {
            console.warn('Missing perforamnces');
            return 0;
          }
          if (a.Performance[this.performance[0]] === b.Performance[this.performance[0]]) {
            if (a.Performance[this.performance[1]] === b.Performance[this.performance[1]]) {
              return b.Performance[this.performance[2]] - a.Performance[this.performance[2]];
            }
            return b.Performance[this.performance[1]] - a.Performance[this.performance[1]];
          }
          return a.Performance[this.performance[0]] > b.Performance[this.performance[0]] ? -1 : 1;
        });
      }
      return arr;
    },

    onTap (e) {
      const element = this.$refs.tools;

      if (e.target !== element && !element.contains(e.target)) {
        this.clickOutsideToClose();
      }
    },
    clearFilters () {
      for (let i = 0; i < this.performance.length; i++) {
        this.$set(this.performance, i, '');
      }
    },
    filterPerformanceList (level) {
      const list = JSON.parse(JSON.stringify(this.performanceList));
      const used0 = list.findIndex(obj => obj.value === this.performance[0]);
      const used1 = list.findIndex(obj => obj.value === this.performance[1]);
      if (level > 0 && used0 !== -1) {
        list[used0].disabled = true;
      }
      if (level > 1 && used1 !== -1) {
        list[used1].disabled = true;
      }
      return list;
    },
    filterHasChanged (e) {
      this.enableShuffle();
      this.$store.dispatch('productList/updateAreaOfUseFilters', e);
    },
    setDefaultPerformances () {
      for (let i = 0; i < this.performance.length; i++) {
        const data = this.header[`Performances${i + 1}`];
        if (data > 0) {
          const p = this.performanceList.find(p => p.id === data);
          if (p) {
            this.$set(this.performance, i, p.value);
          }
        }
      }
      // urldata overwrites default data (from header)
      this.updateFromUrlParam();
    },
    updateFromUrlParam () {
      const size = parseInt(stringHelper.getURLParameter('s'), 10);
      const docHeight = parseInt(stringHelper.getURLParameter('h'), 10);
      for (let i = 0; i < this.performance.length; i++) {
        const urlData = stringHelper.getURLParameter(`pf${i + 1}`);
        if (typeof urlData !== 'undefined') {
          this.$set(this.performance, i, urlData);
        }
      }
      if (size > 0) this.startPages = size;
      if (docHeight > 0) document.body.style.minHeight = `${docHeight}px`;
    },
    performanceChange () {
      for (let i = 0; i < this.performance.length; i++) {
        const pf = this.performance[i];
        let url = window.location.href;
        if (pf !== '' && pf !== undefined) {
          url = stringHelper.updateUrlParameter(url, `pf${i + 1}`, pf);
        } else {
          url = stringHelper.removeUrlParameter(url, `pf${i + 1}`);
        }
        stringHelper.replaceUrlState(url);
      }
    },
    async getPerformanceInfo () {
      const url = '/api/product/performances';
      const result = await Api.getContentByFriendlyUrl(url);
      this.$store.dispatch('productList/updatePerformanceRatingInfo', result.data.performances);
    },
    openMobileTools () {
      this.animatingTools = true;
      setTimeout(() => {
        this.animatingTools = false;
      }, 1000);
      this.viewMobileTools = true;
    },
    closeMobileTools () {
      this.viewMobileTools = false;
    },
    clickOutsideToClose () {
      if (this.viewMobileTools && !this.animatingTools) {
        this.closeMobileTools();
      }
    }

  },
  watch: {
    header: {
      handler () {
        // track: gender, page title
        if (this.header.Gender && this.header.DisplayName && !this.tracked) {
          this.tracked = true;
          TrackerProductGuideViewed(this.header.Gender, this.header.DisplayName);
        }
        this.setDefaultPerformances();
      }
    },
    products (newval) {
      if (this.products.length > 0) { this.productList = [...this.products]; }
    },
    performance () {
      for (let i = 1; i < this.performance.length; i++) {
        if (this.performance[i] === this.performance[i - 1]) {
          this.performance[i] = '';
        }
        if (i > 1 && this.performance[i] === this.performance[i - 2]) {
          this.performance[i] = '';
        }
      }
      this.performanceChange();
    },
    productsLoading: function (newval) {
      if (!newval && this.products.length > 0) {
        if (this.waitingForList) {
          this.$_removePageLoader();
          if (this.$mqAliases.xs || this.$mqAliases.sm) {
            setTimeout(() => {
              this.openMobileTools();
            }, 2500);
          }
        }
        this.waitingForList = false;
      }
    }

  },
  mounted () {
    this.getPerformanceInfo();

    this.$store.dispatch('productList/changeProductPageSize', 'unlimited');
    this.$store.dispatch('productList/getProductList', 1);
  }
};
</script>
<style lang="scss" src="@/scss/components/components.bar-container.scss"></style>
<style lang="scss">
@import "@/scss/defaults.scss";
.product-guide {
  min-height: 100vh;
  &.-mobiletools {
    .product-card-list-wrapper {
      overflow: hidden;
      position: relative;
    }
  }
  .product-card-list-wrapper.-shuffle {
    min-height: 100vh;
  }
  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 28000;
    width: 100vw;
    height: 100vh;
    background-color: rgba(245, 245, 245, 0.75);
  }
  .-stickytools {
    position: sticky;
    top: 60px;
    @include media-breakpoint-down(sm) {
      position: fixed;
      bottom: 0;
      top: unset;
      left: 0;
      width: 100%;
      max-width: 100vw;
      padding: 18px 0;
      z-index: 30000;
      background-color: $white;
      transform: translateY(100vh);
      transition: transform 0.66s;
      > div {
        padding: 0 18px;
        &.product-guide-performance {
          padding: 0;
        }
        .product-guide-performance-header {
          padding: 0 18px;
        }
        .select-wrapper {
          padding-left: 18px;
        }
      }
      &.-open {
        transform: translateY(0);
      }
      .select-simple {
        display: inline-block;
      }
      .select-wrapper {
        display: flex;
        width: 100vw;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }

  .topbar {
    margin-left: -18px;
    padding-left: 18px;
    width: 100vw;
    margin-bottom: 0 !important;
    position: sticky;
    top: 3.75rem;
    z-index: 21000;
  }
  .filter-list {
    display: flex;
    flex-direction: column;
    padding: 9px 0;
    @include media-breakpoint-down(sm) {
      max-height: 50vh;
      overflow-y: scroll;
    }
    li {
      list-style-type: none;
      &.-hidden {
        display: none;
      }
    }

    .filter-item {
      padding: 6px;
      @include media-breakpoint-up(lg) {
        padding: 4.5px;
      }
      padding-left: 0;
      list-style-type: none;
      &:hover {
        background-color: $gray-lighter;
        border-radius: 3px;
      }
    }
    .checkbox label {
      @include font-responsive(body);
    }
    @include media-breakpoint-down(sm) {
      // flex-direction: row;
      // flex-wrap: wrap;
      // .filter-item {
      //   margin-right: 9px;
      // }
    }
  }
}
</style>
